import _ from 'lodash';
import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from '@/store';
import {getListOfUrlParameters} from '@/utils/urlHelpers'

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL || '/',
  //mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({x: 0, y: 0})
      }, 0)
    })
  },
  routes: [{
      path: "/",
      name: "home",
      component: Home,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/reward/:id',
      name: "reward-details",
      component: () => import('./views/RewardDetail.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/account",
      name: "account",
      component: () => import('./views/Account.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import('./views/Profile.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/edit-profile",
      name: "edit-profile",
      component: () => import('./views/EditProfile.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/activities",
      name: "activities",
      component: () => import('./views/Activities.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/promo-codes",
      name: "promo-codes",
      component: () => import('./views/PromoCodeList.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/coupon-scan",
      name: "coupon-scan",
      component: () => import('./views/CouponScan.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/messages",
      name: "messages",
      component: () => import('./views/Messages.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/point-expiration',
      name: 'point-expiration',
      component: () => import('./views/PointExpiration'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/sign-in/token/:token?',
      name: 'direct-login',
      component: () => import('./views/DirectLogin.vue')
    },
    {
      path: '/external-login/:token?',
      name: 'external-login',
      component: () => import('./views/ExternalLogin.vue')
    },
    {
      path: '/rating/vote',
      name: 'user-rating',
      component: () => import('./views/UserRatings.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/install-webapp',
      name: 'install-webapp',
      component: () => import('./views/InstallWebapp.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/verify-email",
      name: "verify-email",
      component: () => import('./views/VerifyEmail.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/verification',
      name: 'verification',
      component: () => import('./views/Verification.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/ForgotPassword.vue')
    },
    {
      path: '/wallet-pass',
      name: 'wallet-pass',
      component: () => import('./views/WalletPassForm.vue')
    },
    {
      path: '/customer-login',
      name: 'customer-login',
      component: () => import('./views/CustomLogin.vue')
    },
    {
      path: '/open-id',
      name: 'openid',
      component: () => {}
    },
    {
      path: '/sign-in',
      name: 'signin',
      component: () => {
        if (
          _.get(
              store.getters.extensionSettings,
              'webview.custom_login_screen',
              null
          )
        ) {
          return import('./views/CustomLogin.vue')
        } else if (
            _.get(
                store.getters.extensionSettings,
                'webview.registration_mode',
                ''
            ) === 'sms'
        ) {
          if (_.get(store.getters.authSettings, 'otpConfig.enabled', false)) {
            return import('./views/Signin.vue')
          } else {
            return import('./views/SMSSignin.vue')
          }
        } else {
          return import('./views/Signin.vue')
        }
      }
    },
    {
      path: '/verify-otp-signin',
      name: 'verify-otp-signin',
      beforeEnter: (to, from, next) => {
        const identifier = _.get(store, 'state.userIdentifierForVerification')
        if (!identifier) {
          next({name: 'signin'})
        } else {
          next()
        }
      },
      component: () => import('./views/SMSSignin.vue')
    },
    {
      path: '/disabled-mode',
      name: 'disabled-mode',
      component: () => import('./views/DisabledMode.vue')
    },
    // added a new route for disabled mode, since the route /disabled-mode is coupled with web view extension
    {
      path: '/wallet-pass-disabled-mode',
      name: 'wallet-pass-disabled-mode',
      component: () => import('./views/DisabledMode.vue')
    },
    {
      path: '/maintenance-mode',
      name: 'maintenance-mode',
      component: () => import('./views/MaintenanceMode.vue')
    },
    {
      path: '/not-found',
      name: 'notfound',
      component: () => import('./views/NotFound2.vue')
    },
    {
      path: '/join',
      name: 'join',
      // component: () => import('./views/Join.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(
    (record) => record.meta.authRequired
  );
  const isAuthenticated = store.state.auth.isAuthenticated;
  const emailVerificationRequired =
    store.getters.isEmailVerificationRequired;
  let webviewExtension = null
  const webviewExtensionSettings = _.get(store.getters.extensionSettings, 'webview', null)
  if (webviewExtensionSettings !== null) {
    const isDisabled = _.get(webviewExtensionSettings, 'disabled_web_app', false)
    if (isDisabled) {
      webviewExtension = null
    } else {
      webviewExtension = webviewExtensionSettings
    }
  }
  const walletPassExtension = _.get(
    store.getters.extensionSettings, 'wallet_pass', null
  );
  const maintenanceMode = _.get(
    webviewExtension, 'maintenance_mode', false
  );
  const registrationMode = _.get(
    store.getters.extensionSettings, 'webview.registration_mode', ''
  );
  const verificationAttributes = store.getters.verificationAttributes;
  const verificationAttributesAreEmpty = _.every(
    verificationAttributes,
    (formAttributesGroup) => {
      return _.every(
        formAttributesGroup,
        (attributesInnerGroup) => {
          return _.isEmpty(attributesInnerGroup.attributes)
        }
      )
    });

  const isOpenIdMode = to.path === '/open-id'

  if (!to.matched.length) {
    next({
      name: 'notfound'
    });
  } else if (
    _.isEmpty(walletPassExtension) &&
    to.path === '/wallet-pass'
  ) {
    next({
      name: 'wallet-pass-disabled-mode'
    });
  } else if (
    !_.isEmpty(walletPassExtension) &&
    to.path === '/wallet-pass'
  ) {
    next();
  } else if (
    _.isEmpty(webviewExtension) &&
    to.path !== '/disabled-mode'
  ) {
    next({
      name: 'disabled-mode'
    });
  } else if (
    !_.isEmpty(webviewExtension) &&
    to.path === '/disabled-mode'
  ) {
    next({
      name: 'home'
    });
  } else if (
    _.isEmpty(webviewExtension) &&
    to.path === '/disabled-mode'
  ) {
    next();
  } else if (
      maintenanceMode &&
      to.path !== '/maintenance-mode'
    ) {
    next({
      name: 'maintenance-mode'
    });
  } else if (
    !maintenanceMode &&
    to.path === '/maintenance-mode'
  ) {
    next({
      name: 'home'
    });
  } else if (
      maintenanceMode &&
      to.path === '/maintenance-mode'
    ) {
    next();
  } else if (
    registrationMode === 'sms' &&
    to.path === '/register'
  ) {
    next({
      name: 'signin'
    });
  } else if (
    !_.isEmpty(to.query['external-user-token'])
  ) {
    next({
      name: 'external-login',
      params: {
        token: to.query['external-user-token']
      }
    });
  } else if (
    to.path === '/customer-login' &&
    _.isEmpty(to.params)
  ) {
    next({
      name: 'signin'
    });
  } else if (
    authRequired &&
    !isAuthenticated &&
    to.query.token
  ) {
    const redirectParams = _.omit(to.query, ['token', 'redirect']);

    next({
      name: 'direct-login',
      params: {
        token: to.query.token,
        redirect: to.path,
        ...redirectParams,
      }
    });
  } else if (authRequired && !isAuthenticated) {
    next({
      name: 'signin'
    });
  } else if (
    authRequired &&
    emailVerificationRequired &&
    to.path !== '/verify-email'
  ) {
    next({
      name: 'verify-email'
    });
  } else if (
    authRequired &&
    !emailVerificationRequired &&
    to.path === '/verify-email'
  ) {
    next({
      name: 'home'
    });
  } else if (
    (authRequired || isOpenIdMode) &&
    !emailVerificationRequired &&
    !verificationAttributesAreEmpty &&
    to.path !== '/verification'
  ) {
    next({
      name: 'verification'
    });
  } else if (
    authRequired &&
    !emailVerificationRequired &&
    verificationAttributesAreEmpty &&
    to.path === '/verification'
  ) {
    next({
      name: 'home'
    });
  } else if (authRequired && isAuthenticated) {
    const currentTosVersion = _.get(
      store.getters.extensionSettings,
      'auth.current_tos_version',
      0
    );
    const acceptedTosVersion = _.get(
      store.state.user,
      'accepted_tos_version'
    );

    if (
      _.isNil(acceptedTosVersion) ||
      acceptedTosVersion < currentTosVersion
    ) {
      store.dispatch('tosScreen', {show: true});
    }

    next();
  } else if (to.path === '/open-id') {
    // Step 1 -
    // Obtain OpenId parameters from route
    const openIdParams = ['redirect_uri', 'client_id', 'state', 'scope', 'response_type', 'nonce']
    Object.assign(to.query, getListOfUrlParameters(openIdParams, '#/open-id'))

    // Step 2 -
    // define the function that will handle the authentication or redirect within the router context
    const handleAuthenticationOrRedirect = () => {
      if (!store.getters.isAuthenticated) {
        next({name: 'signin'});
      } else {
        store.dispatch('manageOpenIdRedirect', to.query)
      }
    }

    // Step 3 - Sets the OpenId parameters in the store
    store.dispatch('setAuthParams', to.query)
    // Step 4 - manage the openId flow, providing the redirect function from this router
        .then(() => { store.dispatch('manageOpenIdLogin', {handleAuthenticationOrRedirect}) })

  } else if (
    !authRequired &&
    isAuthenticated &&
    (
      to.name !== 'external-login' &&
      _.isEmpty(to.query['external-user-token'])
    )
  ) {
    next({
      name: 'home'
    });
  } else {
    next();
  }
});

export default router;
